import { render, staticRenderFns } from "./UICheckbox.vue?vue&type=template&id=4af6f84d&"
import script from "./UICheckbox.vue?vue&type=script&lang=js&"
export * from "./UICheckbox.vue?vue&type=script&lang=js&"
import style0 from "./UICheckbox.vue?vue&type=style&index=0&id=4af6f84d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports